import { useQuery } from "@tanstack/react-query";
import { watchlistApi } from "@/api/ux";

/**
 * Page-level batch star-status lookup for list pages: one
 * GET /api/watchlist/status call for the whole page instead of one
 * GET /watchlist/{type}/{id} per row (the broker-list N+1). Feed the result
 * into each row's <StarButton isWatching={...} /> so the per-row query is
 * skipped. StarButton mutations invalidate the ["watchlist"] prefix, which
 * covers this key.
 */
export function useWatchlistStatuses(entityType: string, entityIds: string[]) {
  // Sorted copy so the key is stable across re-orders of the same page.
  const key = [...entityIds].sort().join(",");
  return useQuery({
    queryKey: ["watchlist", "statuses", entityType, key],
    queryFn: () => watchlistApi.statuses(entityType, entityIds),
    enabled: entityIds.length > 0,
  });
}
